import { useState } from 'react';
import { templates } from '../data/templates';
import TemplateSelector from '../components/TemplateSelector';
import PromotionForm from '../components/PromotionForm';
import { PageTitle } from '../../../../../_metronic/layout/core';

export default function CreatePromotionPage() {
  const [selectedTemplateId, setSelectedTemplateId] = useState<string | null>(null);

  const selectedTemplate = templates.find((t) => t.id === selectedTemplateId) ?? null;

  const handleSelectTemplate = (id: string) => {
    setSelectedTemplateId(id);
  };

  const handleResetTemplate = () => {
    setSelectedTemplateId(null);
  };

  return (
    <div className="h-[calc(100vh-150px)] bg-gray-50">
      <PageTitle>Briefing de Promoções</PageTitle>
      <div className="mx-auto">
        <div className="rounded-lg border border-gray-200 bg-white p-6 animate-fade-in md:p-8">
          {!selectedTemplate ? (
            <TemplateSelector
              templates={templates}
              selectedId={selectedTemplateId}
              onSelect={handleSelectTemplate}
            />
          ) : (
            <PromotionForm
              template={selectedTemplate}
              onReset={handleResetTemplate}
            />
          )}
        </div>
      </div>
    </div>
  );
}